import { render, staticRenderFns } from "./VasDetailsWeshope.vue?vue&type=template&id=00a0ee80&scoped=true&"
import script from "./VasDetailsWeshope.vue?vue&type=script&lang=ts&"
export * from "./VasDetailsWeshope.vue?vue&type=script&lang=ts&"
import style0 from "./VasDetailsWeshope.vue?vue&type=style&index=0&id=00a0ee80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a0ee80",
  null
  
)

export default component.exports